import React, { useState, useEffect } from "react";
import {  getDoc,  updateDoc, doc } from "firebase/firestore";
import { db } from "../firebase-config/firebase";
import { useParams } from 'react-router-dom'
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);

const CreateDate = () => {
  const [nombre, setNombre] = useState('')
  const [apellidos, setApellidos] = useState('')
  const [lugar, setLugar] = useState('')
  const [fecha, setFecha] = useState('')
  const [hora, setHora] = useState('')
  const { id } = useParams()
  const navigate = useNavigate()
  
  const getAdultoById = async (id) => {

    const adulto = await getDoc(doc(db, "adultosm", id))
    setApellidos(adulto.data().apellidos)
    setNombre(adulto.data().nombre)
  }

  const storeDate = async (e) => {
    e.preventDefault()
    const adultodoc = doc(db, "adultosm", id)
    const adulto = await getDoc(adultodoc)
    const datos = adulto.data()
    if (datos.citas === undefined) {
      datos.citas  = []
    }
    datos.citas.push({
        lugar: lugar,
        fecha: fecha,
        hora: hora
    })
    const data = {
      citas: datos.citas
    }
    MySwal.fire({     
      icon: "success",
      title: "Cita Agregada!",
      showConfirmButton: false,
      timer: 1500
    });
    await updateDoc(adultodoc, data)
    navigate(`/home/showAdult/${id}`)  
  }

  useEffect(() => {
    getAdultoById(id)
    //eslint-disable-next-line
  }, [])

  return (
    <div className="container">
      <div className='Header'>
        <div className="row"> <h1>Crear Cita</h1> </div>
        <div className='underlineC'></div>
      </div>

      <div className="row">

        <div className="col">

          <div className="row">
            <input disabled className="cornerSearch" value={nombre + " " + apellidos} type="text"></input>
          </div>

          <section className='container my-2 bg-dark w-adapt text-light p-2 rcorners'>
            <form onSubmit={storeDate} className='p-4 row g-2 formShadow'>

              <div className='mb-3'>
                <label className='form-label'>Lugar de la cita</label>
                <input
                  value={lugar}
                  onChange={(e) => setLugar(e.target.value)}
                  type="text"
                  className='form-control'

                />
              </div>
              <div className='mb-3'>
                <label className='form-label'>Fecha</label>
                <input
                  value={fecha}
                  onChange={(e) => setFecha(e.target.value)}
                  placeholder="Seleccionar fecha"
                  type="date"
                  className='form-control'

                />
              </div>
              <div className='mb-3'>
                <label className='form-label'>Hora</label>
                <input
                  value={hora}
                  onChange={(e) => setHora(e.target.value)}
                  type="time"
                  className='form-control'
                  placeholder='Seleccionar hora'
                />
              </div>

              
                           
              <button type='submit' className='submit'>Ingresar</button>
            </form>  
          </section>
        </div>
      </div>
    </div>
   
    
  )

}

export default CreateDate